export default __webpack_public_path__ + "static/media/guru-parampara-banner.e835241e.png";